import { render, staticRenderFns } from "./symbolGroupModal.vue?vue&type=template&id=3889e3ce&scoped=true&"
import script from "./symbolGroupModal.vue?vue&type=script&lang=js&"
export * from "./symbolGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3889e3ce",
  null
  
)

export default component.exports